import React from "react";
import Modal from "react-modal";
import GiftCard from "../../assets/GiftCard.svg";
import Confetti from "react-confetti";

type CustomModalForRegistrationProps = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  children?: React.ReactNode;
  height?: string;
  onClose?: () => void;
  parent?: boolean;
  overflow?: boolean;
};

const CustomModalForRegistration: React.FC<CustomModalForRegistrationProps> = ({
  modalVisible,
  setModalVisible,
  children,
  height,
  onClose,
  parent,
  overflow,
}) => {
  const isMobile = window.innerWidth < 768;

  const handleClose = () => {
    if (!parent) {
      setModalVisible(false);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={modalVisible}
      onRequestClose={() => handleClose()}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)", // black background with 50% opacity
          zIndex: 999, // z-index of 999
        },
        content: {
          zIndex: 999,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderWidth: 0,
          backgroundColor: "transparent",
        },
      }}
    >
      {/* <Confetti width={window.innerWidth} height={window.innerHeight}  /> */}
      <div
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          display: "flex",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            borderRadius: 20,
            zIndex: 200,
          }}
        >
          <img
            src={GiftCard}
            alt=""
            style={{ width: 242, height: 155, objectFit: "contain" }}
          />
        </div>
        <div
          style={{
            padding: "20px",
            maxWidth: "500px",
            overflow: overflow ? "hidden" : "auto",
            backgroundColor: "white",
            marginTop: 120,
            borderRadius: 20,
          }}
        >
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default CustomModalForRegistration;
